import React from 'react'
import { Col } from 'reactstrap'
import styles from './Oops.module.scss'

import OopsIcon from '../../images/oops_caption.svg';


function Oops({ message }){
  return (
    <Col className="text-center">
      <img src={OopsIcon} alt="OOPS!" className="mb-4"/>
      <p className={styles['caption-text']}>{message}</p>
    </Col>
  )
}

export default Oops;
